import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LoginBackground } from '@/components/LoginCard';

export function NetworkCheckingSplash() {
  const { t } = useTranslation('entity-portal');

  return (
    <LoginBackground>
      <Stack spacing={2} alignItems="center" role="status" aria-live="polite">
        <Box
          component="img"
          src="/img/cslogo.svg"
          alt="Creditsafe"
          sx={{ height: 32 }}
        />
        <CircularProgress aria-hidden />
        <Typography variant="body2" color="text.secondary">
          {t('network.networkCheckingLabel')}
        </Typography>
      </Stack>
    </LoginBackground>
  );
}
